module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"articles":"Статьи","date":"Дата","blog":"Блог","title":"Заголовок","createArticle":"Добавить статью"}}')
  delete Component.options._Ctor
}
